<app-countable-button [asIcon]="isIconButton"
  [count]="orderCount"
  [matMenuTriggerFor]="print"
  [withoutBadge]="withoutBadge"
  [disabled]="disabled">
  <mat-icon>print</mat-icon>
  <mat-label>{{ 'ORDERS.COMMON.PRINTING_BUTTON.printing_button' | translate }}</mat-label>
</app-countable-button>

<mat-menu #print="matMenu" [overlapTrigger]="false" xPosition="before">
  @if (pools.length) {
    <mat-optgroup [label]="'ORDERS.COMMON.PRINTING_BUTTON.pools_group' | translate">
      @for (pool of pools; track pool) {
        <mat-option (click)="onPoolPrinting(pool)">
          {{ pool.name }}
        </mat-option>
      }
    </mat-optgroup>
    <mat-divider></mat-divider>
  }
  @for (pair of documentGroups; track pair) {
    <mat-optgroup [label]="pair.isDefault ? ('ORDERS.COMMON.PRINTING_BUTTON.additional_group' | translate) : pair.group">
      @for (document of pair.documents; track document) {
        <mat-option (onSelectionChange)="onSinglePrinting(document)">
          {{ document.name }}
        </mat-option>
      }
    </mat-optgroup>
  }
</mat-menu>
